import { render, staticRenderFns } from "./SwitchCheckbox.vue?vue&type=template&id=56a2261e&scoped=true&"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=js&"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./SwitchCheckbox.vue?vue&type=style&index=0&id=56a2261e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a2261e",
  null
  
)

export default component.exports